import React  from 'react';

import TextField from 'material-ui/TextField';

class Name extends React.PureComponent {
    render() {
        const { name, confirmed, getError, changeField, modifiedFields, underStyle } = this.props;

        return (
            <div className='row'>
                <div className='col-xs-12'>
                    <TextField
                        name='name'
                        disabled={confirmed}
                        floatingLabelText='Name'
                        value={name || ''}
                        onChange={(e, value) => {
                            changeField({
                                field: 'name',
                                value,
                            });
                        }}
                        errorText={getError('name')}
                        fullWidth

                        underlineStyle={modifiedFields && modifiedFields.includes('name') ? underStyle : null}
                    />
                </div>
            </div>
        );
    }
}

export default Name


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Name.jsx